import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2413449777 from "../../../../../packages/component/src/components/pagination/demo/demo1.js?loadDemo";
import legacyImportDemo_828523026 from "../../../../../packages/component/src/components/pagination/demo/demo2.js?loadDemo";
import legacyImportDemo_1461981299 from "../../../../../packages/component/src/components/pagination/demo/demo3.js?loadDemo";
import legacyImportDemo_3895578964 from "../../../../../packages/component/src/components/pagination/demo/demo4.js?loadDemo";
import legacyImportDemo_1119239605 from "../../../../../packages/component/src/components/pagination/demo/demo5.js?loadDemo";
import legacyImportDemo_4068440470 from "../../../../../packages/component/src/components/pagination/demo/demo6.js?loadDemo";
import legacyImportDemo_1350723063 from "../../../../../packages/component/src/components/pagination/demo/demo7.js?loadDemo";
import legacyImportDemo_1957687512 from "../../../../../packages/component/src/components/pagination/demo/demo8.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2413449777,
  legacyImportDemo_828523026,
  legacyImportDemo_1461981299,
  legacyImportDemo_3895578964,
  legacyImportDemo_1119239605,
  legacyImportDemo_4068440470,
  legacyImportDemo_1350723063,
  legacyImportDemo_1957687512,
  React
};